export default {
  // Dashboard
  dashboard: '/dashboard',

  // ASR
  asr: '/asr',

  // Audio File to Text
  audio_file_to_text_task: '/task',
  audio_file_to_text_add_file: '/queue',
  audio_file_to_text_download: '/transcript',

  // Setting
  users: '/setting/users',
  group: '/setting/users/group',
  logs: '/setting/logs',

  // Auth
  login: '/login',
  logout: '/logout',
  otp: '/verify_otp',
  token: '/verify',
  forgot_password: '/forgot_password'
}
